export default "__VITE_ASSET__24b90b9e__"